import request from '@/utils/request'

let get = (data) => request.post('/api/imeiPassword/get', data)

export default {
  get
}